import { IconButton } from '@mui/material';
import { LogOut, Star } from 'lucide-react';

import { TeamRole } from '@labradorsports/components';
import { JoinTypes } from '@labradorsports/constants';
import { getTeamUserRole } from '@labradorsports/utils';

interface Props {
    team: Team;
    program: Program;
    selectTeam: (team: Team) => void;
    uid: string;
    leaveTeam: (team: Team) => void;
    favoriteTeam: (team: Team) => void;
    isFavorite: boolean;
}

const TeamsMenuItem: FC<Props> = ({ team, program, selectTeam, uid, leaveTeam, favoriteTeam, isFavorite }) => {
    const classNames = ['teams-menu-item'];

    const role = getTeamUserRole(team, uid);

    if (team.pending) {
        classNames.push('pending');
    }

    const leave = (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
        leaveTeam(team);
    };

    const favorite = (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.stopPropagation();
        favoriteTeam(team);
    };

    return (
        <div onClick={() => selectTeam(team)} className={classNames.join(' ')}>
            <div className="flex-grow-1">
                <span className="team-name">
                    {team.name ? team.name : <i>Unnamed Team </i>}
                    {isFavorite ? <Star className="ms-2" stroke="#F3B471" fill="#F3B471" size={12} /> : null}
                </span>
                <br />
                <TeamRole team={team} program={program} uid={uid} />
            </div>
            <IconButton onClick={favorite}>
                <Star />
            </IconButton>
            {role === JoinTypes.ADMIN ? null : (
                <IconButton color="error" onClick={leave}>
                    <LogOut />
                </IconButton>
            )}
        </div>
    );
};

export default TeamsMenuItem;
